import { z } from 'zod'

import { feeSchema, pricingBreakdownSchema } from './schemas/pricing'

const _pricingBreakdownSchema = z.object(pricingBreakdownSchema)

export type Fee = z.infer<typeof feeSchema>
export type PricingBreakdown = z.infer<typeof _pricingBreakdownSchema>
